/*
Author: Nishant Singh
Description: Every reducer name should be name followed by suffix Reducer with camelCase.
*/

import {
  AUTHENTICATE,
  USER_ME,
  USER_DATA,
  USER_MENU,
  TOTAL_NOTIFICATION,
} from '../actions';

const initialState = {
  isLoggedIn: false,
  userMeFetched: false,
  token: null,
  user: {},
  userId: null,
  menuPermission: [],
  notificationCount: 0,
};

const authReducer = (state = initialState, action) => {
  const data = action.data;
  switch (action.type) {
    case AUTHENTICATE:
      return {
        ...state,
        isLoggedIn: data.token ? true : Boolean(data.userId),
        ...data,
      };
    case USER_ME:
      return { ...state, userMeFetched: action.data };
    case USER_DATA:
      return { ...state, user: action.data };
    case USER_MENU:
      return { ...state, menuPermission: action.data };
    case TOTAL_NOTIFICATION:
      return { ...state, notificationCount: action.data };
    default:
      return state;
  }
};

export default authReducer;
